/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {useGoogleLogin} from '@react-oauth/google'
import axios from 'axios'
import api from '../../../api'
import {GoogleUserPayload} from '../../../api/models/payload/GoogleUserPayload'
import CryptoLogo from '../../../../app/assets/images/CryptoLogo.png'
import MeslLogo from '../../../../app/assets/images/MESL.png'
import {isCryptoEntity} from '../../../../app/api/client'
import {  } from '../../../api/rest/auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        var qs = require('qs')
        const data = {
          username: values.email,
          password: values.password,
          client_id: 'swaggerui',
          client_secret: 'secret',
        }
        const {data: auth} = await api.auth.login(qs.stringify(data))
        saveAuth(auth)
        const {data: user} = await api.auth.getUserByToken(auth.access_token)
        setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const [userData, setUserData] = useState<any>()
  const [profile, setProfile] = useState<any>()
  const [agreementID, setAgreementId] = useState<number>(0)

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => setUserData(codeResponse),
    onError: (error) => console.log('Login Failed:', error),
  })

  useEffect(() => {
     console.log('lu', userData)
    if (userData) {
      console.log('la', userData)

      getGoogleUserData()
    }
  }, [userData])

  useEffect(() => {
    if (profile && agreementID != 0) {
      console.log('la', profile)

      addGoogleUser()
      authenticateGoogleUser()
    }
  }, [profile, agreementID])

  const getGoogleUserData = async () => {
    const tempprofile = await axios.get(
      `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${userData.access_token}`,
      {
        headers: {
          Authorization: `Bearer ${userData.access_token}`,
          Accept: 'application/json',
        },
      }
    )
    setProfile(tempprofile.data)
    await getAgreementConsent()
  }

  const getAgreementConsent = async () => {
    const res = await api.agreement.get()
    setAgreementId(res.data.id)
  }

  const addGoogleUser = async () => {
    const userPayload: GoogleUserPayload = {
      email: profile?.email,
      externalToken: userData.access_token,
      agreements: [agreementID],
    }
    await api.google.addGoogleUser(userPayload)
  }

  const authenticateGoogleUser = async () => {
    const data = {
      token: userData.access_token,
      username: profile?.email,
      client_id: 'swaggerui',
      client_secret: 'secret',
    }
    const {data: auth} = await api.auth.googleAuth(data)
    saveAuth(auth)
    const {data: user} = await api.auth.getUserByToken(auth.access_token)
    setCurrentUser(user)
  }

  // log out function to log the user out of google and set the profile array to null
  // const logOut = () => {
  //     googleLogout();
  //     setProfile(null);
  // };

  const selectLogo = isCryptoEntity ? CryptoLogo : MeslLogo

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <img
        className='mx-auto w-275px w-md-50 w-xl-200px mb-10 mb-lg-12 d-flex'
        src={selectLogo}
        alt=''
      />
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
        {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
      </div>
      {/* begin::Heading */}

      {/* begin::Login options */}
      <div className='row g-3 mb-9'>
        {/* begin::Col */}
        <div className='col-md-6' style={{margin: 'auto'}}>
          {/* <GoogleLogin onSuccess={responseMessage} onError={() => errorMessage} /> */}
          <a
            onClick={() => googleLogin()}
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            Sign in with Google
          </a>
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        {/* <div className='col-md-6'>
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            Sign in with Apple
          </a>
        </div> */}
        {/* end::Col */}
      </div>
      {/* end::Login options */}

      {/* begin::Separator */}
      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div>
      {/* end::Separator */}

      {
        formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )
        // <div className='mb-10 bg-light-info p-8 rounded'>
        //   <div className='text-info'>
        //     Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
        //     continue.
        //   </div>
        // </div>
      }

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
        <input
          placeholder='Password'
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      {/* <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
      </div> */}
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div> */}
    </form>
  )
}
